if (window.matchMedia("(max-width: 490px)").matches) {
    
    const scrollTopBtn = document.createElement("button");
    scrollTopBtn.innerHTML = '↑'; 
    scrollTopBtn.style.position = "fixed";
    scrollTopBtn.style.bottom = "calc(13.33333vw + 16px)";
    scrollTopBtn.style.right = "5.33333vw";
    scrollTopBtn.style.width = "34px";
    scrollTopBtn.style.height = "34px";
    scrollTopBtn.style.backgroundColor = "white";
    scrollTopBtn.style.color = "black";
    scrollTopBtn.style.border = "1px solid #EFEFEF";
    scrollTopBtn.style.borderRadius = "50%";
    scrollTopBtn.style.fontSize = "16px"; 
    scrollTopBtn.style.cursor = "pointer";
    scrollTopBtn.style.display = "none";
    scrollTopBtn.style.justifyContent = "center";
    scrollTopBtn.style.alignItems = "center";
    scrollTopBtn.style.transition = "opacity 0.3s";
    scrollTopBtn.style.textAlign = "center";

    document.body.appendChild(scrollTopBtn);

    function toggleScrollButton() {
        if (window.scrollY > 300) {
            scrollTopBtn.style.display = "flex";
        } else {
            scrollTopBtn.style.display = "none";
        }
    }

    toggleScrollButton();

    window.addEventListener("scroll", toggleScrollButton);

    scrollTopBtn.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}